// @ts-nocheck
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { ProfilePicture } from '../ProfilePicture'

export default class SeenByList extends Component {
  state = {
    isExpanded: false,
  }

  toggleExpand = () => {
    this.setState((prevState) => ({
      isExpanded: !prevState.isExpanded,
    }))
  }

  renderPicture = (carer) => {
    if (!carer) return null
    return (
      <div key={carer.id} style={styles.rows}>
        <ProfilePicture
          type="handover__small"
          url={carer.picture}
          style={styles.image}
        />
        <span
          style={this.state.isExpanded ? styles.textColumn : styles.textRow}
        >
          {carer.name ? `${carer.name.first} ${carer.name.last}` : null}
        </span>
      </div>
    )
  }

  render() {
    const { seenBy } = this.props
    const { isExpanded } = this.state

    if (!seenBy || !seenBy.length) return null

    return (
      <div style={styles.mainContainer}>
        <div
          style={{
            ...styles.containerSeenBy,
            flexDirection: 'row',
          }}
          onClick={() => this.toggleExpand()}
        >
          <span style={styles.seen}>Seen by</span>
          <div
            style={{
              display: 'flex',
              flexDirection: isExpanded ? 'column' : 'row',
              flexWrap: 'wrap',
            }}
          >
            {seenBy.map((carer) => {
              if (!carer) return null
              return (
                <div
                  key={carer.id}
                  style={isExpanded ? styles.imageContainerColumn : null}
                >
                  {this.renderPicture(carer)}
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )
  }
}

const styles = {
  containerSeenBy: {
    display: 'flex',
    cursor: 'pointer',
    padding: '20px 0px 20px 0px',
  },
  seen: {
    paddingTop: 8,
    opacity: 0.8,
    fontSize: 12,
    marginRight: 10,
    flexShrink: 0,
  },
  imageContainerColumn: {
    padding: '0px 4px 2px 0px',
  },
  image: {
    marginRight: 2,
  },
  rows: {
    display: 'flex',
    flexDirection: 'row',
  },
  textRow: {
    display: 'none',
  },
  textColumn: {
    fontSize: 12,
    opacity: 0.6,
    padding: '8px 0px 0px 10px',
  },
}

SeenByList.propTypes = {
  carers: PropTypes.array,
  seenBy: PropTypes.array.isRequired,
}
